import { ApiClient, ServiceBase } from './api'
import { mockAuthService } from './mockData'

import type {
  ApiResponse,
  CheckStatusResponse,
  LoginResponse,
  QRCodeResponse,
  UserInfo
} from '@/types/auth'

export class AuthService extends ServiceBase {
  constructor(client: ApiClient) {
    super(client, '/auth')
  }

  // 企业内免登录
  async enterpriseLogin(authCode: string, corpId: string): Promise<LoginResponse> {
    return this.withMockFallback(
      () => mockAuthService.enterpriseLogin(authCode, corpId),
      () => this.post<LoginResponse>('/dingtalk/login', { authCode, corpId })
    )
  }

  // 获取扫码登录二维码
  async getQRCode(): Promise<QRCodeResponse> {
    return this.withMockFallback(
      () => mockAuthService.getQRCode(),
      () => this.get<QRCodeResponse>('/dingtalk/qrcode')
    )
  }

  // 检查扫码登录状态
  async checkQRCodeStatus(loginKey: string): Promise<CheckStatusResponse> {
    return this.withMockFallback(
      () => mockAuthService.checkQRCodeStatus(loginKey),
      () => this.get<CheckStatusResponse>('/dingtalk/check-status', { 
        params: { login_key: loginKey } 
      })
    )
  }

  // 刷新Token
  async refreshToken(refreshToken: string): Promise<ApiResponse<{
    token: string;
    refreshToken: string;
  }>> {
    return this.withMockFallback(
      () => mockAuthService.refreshToken(refreshToken),
      () => this.post('/auth/refresh', { refreshToken })
    )
  }

  // 退出登录
  async logout(): Promise<ApiResponse> {
    return this.withMockFallback(
      () => mockAuthService.logout(),
      () => this.delete('/user/logout')
    )
  }

  // 获取个人信息 (未实现)
  async getUserProfile(): Promise<ApiResponse<UserInfo>> {
    return this.withMockFallback(
      () => mockAuthService.getUserProfile(),
      () => this.get('/user/profile')
    )
  }

  // 获取用户权限（未实现）
  async getUserPermissions(): Promise<ApiResponse<{
    permissions: string[];
    rolePermissions: Array<{
      roleId: string;
      roleName: string;
      permissions: string[];
    }>;
  }>> {
    return this.withMockFallback(
      () => mockAuthService.getUserPermissions(),
      () => this.get('/user/permissions')
    )
  }

  // 检查权限（未实现）
  // async checkPermission(resource: string, action: string): Promise<ApiResponse<{
  //   hasPermission: boolean;
  //   reason?: string;
  // }>> {
  //   return this.withMockFallback(
  //     () => mockAuthService.checkPermission(resource, action),
  //     () => this.post('/check-permission', { resource, action })
  //   )
  // }
}

export default AuthService